import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "rsuite/dist/rsuite.css";
import "./App.scss";
import Routes from "./router/index";
import { useSelector } from "react-redux";
function App() {
  const { loading, productLoad } = useSelector((state) => state.loaderReducer);

  return (
    <div className="App">
      {(loading || productLoad) && (
        <div className="ns-toploader">
          <div className="ns-toploader__bar" />
          <div className="ns-toploader__pill">
            <div className="ns-toploader__spinner">
              <span className="ns-toploader__ring ns-toploader__ring--1" />
              <span className="ns-toploader__ring ns-toploader__ring--2" />
              <span className="ns-toploader__core" />
            </div>
            <div className="ns-toploader__label">
              <span className="ns-toploader__text">Loading</span>
              <div className="ns-toploader__dots">
                <span /><span /><span />
              </div>
            </div>
          </div>
        </div>
      )}
      <Routes />
      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
